var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: currentColor;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 10,
    r: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.25743,
    y1: 9.19926,
    x2: 9.87068,
    y2: 13.81252
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.51591,
    y1: 6.72069,
    x2: 8.51591,
    y2: 13.72069
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/OKIcon.36cf58161f4d836e4e79e34d4c948289.svg";
export { ForwardRef as ReactComponent };